import { Injectable } from '@angular/core';

@Injectable()
export class AppService {
    changeIntColor(shelves, oldIntColor, intColor) {
        shelves.map((item) => {
            if (item.imgALT.includes(oldIntColor.code)) {
                item.imgALT = item.imgALT.replace(oldIntColor.code, intColor.code);
                item.imgURL = item.imgURL.replace(oldIntColor.code, intColor.code).replace(oldIntColor.url, intColor.url).replace(oldIntColor.code, intColor.code);
            }
        });
        return shelves;
    }
}
